import {action} from "mobx";
import appStore from "./appStore";
import poolShiftService from "../services/poolShiftService";
import generalReportService from "services/generalReportService";
import {b64DecodeToUrl} from "../utils/helpers";

class poolStore {
    @action getDailyForecast = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.getDailyForecast(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action setDailyForecast = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.setDailyForecast(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getPoolShiftForecastByDate = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.getPoolShiftForecastByDate(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action removeDailyForecast = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.removeDailyForecast(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action calculatePoolShiftSlotForecast = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.calculatePoolShiftSlotForecast(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action showDailyForecast = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.showDailyForecast(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action copyForecast = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.copyForecast(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getShiftHours = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.getShiftHours(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getDailyShiftTable = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.getDailyShiftTable(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getDailySlotsByPoolId = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.getDailySlotsByPoolId(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getAllPoolShifts = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.getAllPoolShifts(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action setDailySlotById = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.setDailySlotById(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getCourierShiftTable = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.getCourierShiftTable(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    // Kurye kutusunda yazdıkça çağrıldığı için tam ekran loading açılmaz; kutular kendi
    // loading'ini gösterir.
    @action getPoolCouriers = async params => {
        const resultOfRequest = await poolShiftService.getPoolCouriers(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getCancelRequests = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.getCancelRequests(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action approveCancelRequest = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.approveCancelRequest(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action bookSlotByDateAndHour = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.bookSlotByDateAndHour(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action cancelSlotByDateAndHour = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.cancelSlotByDateAndHour(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action poolShiftsReport = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await generalReportService.poolShiftsReport(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getCourierPoolShifts = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.getCourierPoolShifts(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action downloadPoolShiftExcelFile = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.downloadPoolShiftExcelFile(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        // Uç base64'ü `{success, data}` zarfında döndürüyor (dedike export'u ham string dönüyordu).
        return b64DecodeToUrl(resultOfRequest.data?.data);
    };

    @action changeCourierPoolShiftHour = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.changeCourierPoolShiftHour(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action changeCourierPoolShift = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.changeCourierPoolShift(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action cancelCourierPoolShift = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.cancelCourierPoolShift(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getPoolShiftSyChangeLogs = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.getPoolShiftSyChangeLogs(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getPoolsAvailableRates = async params => {
        //await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.getPoolsAvailableRates(params);
        //await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action bookSlotsWithExcel = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.bookSlotsWithExcel(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action setJokerCourierForShift = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.setJokerCourierForShift(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getPoolCouriersByState = async params => {
        //await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.getPoolCouriersByState(params);
        //await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action bookMultipleSlots = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.bookMultipleSlots(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action createPoolShiftDailySlot = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolShiftService.createPoolShiftDailySlot(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getPoolShiftCountsByForecastDate = async params => {
        const resultOfRequest = await poolShiftService.getPoolShiftCountsByForecastDate(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getActivePoolShiftByForecastDate = async params => {
        const resultOfRequest = await poolShiftService.getActivePoolShiftByForecastDate(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getPlannedPoolShiftByForecastDate = async params => {
        const resultOfRequest = await poolShiftService.getPlannedPoolShiftByForecastDate(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getCompletedPoolShiftByForecastDate = async params => {
        const resultOfRequest = await poolShiftService.getCompletedPoolShiftByForecastDate(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };
}

export default new poolStore();
